

studentTagManagerController = (ModelService, $scope) ->
    'ngInject'

    @tagMap = {}

    $scope.$watchCollection (=> @tags), =>
        @tagMap = {}
        for tag in @tags
            @tagMap[tag.slug] = @tagMap[tag.slug] || {}
            @tagMap[tag.slug][tag.value] = tag
        return

    @reloadTags = (slug, search) ->
        params = slug: slug, q: search
        @searchText = search
        return ModelService
            .getModelRelation(@student, 'tags/available', params)
            .then @processResponse

    @processResponse = (data) =>
        @addableTypes = data.addable_types
        @addableMap = {}
        @addableMap[type.slug] = true for type in @addableTypes
        @selected = data.selected
        @selectedLabel = data.selected_label
        @allTags = data.tags
        @allowNew = not data.exact? and @searchText?.length >= 3
        return

    @hasTag = (tag) ->
        @tagMap[tag.slug]?[tag.value]?

    @clickTag = (tag) ->
        if @hasTag(tag) then @removeTag(tag) else @addTag(tag)

    @addTag = (tag) ->
        tag = {slug: tag.slug, value: tag.value}
        postTag(tag)

    @createTag = (name) ->
        tag = {slug: @selected, name: name}
        postTag(tag).then => @search()

    @removeTag = (tag) ->
        ModelService.untagModel(@student, tag).then (tag) =>
            tag = @tagMap[tag.slug]?[tag.value]
            index = @tags.indexOf(tag)
            @tags.splice(index, 1) if index >= 0
            return tag

    @open = ->
        return @reloadTags().then =>
            @editing = true

    @close = ->
        @editing = false

    @search = (query) -> @reloadTags(@selected, query)
    @setTagGrop = (group) -> @reloadTags(group.slug)

    postTag = (tag) =>
        ModelService.tagModel(@student, tag).then (tag) =>
            @tags.push tag if not @hasTag(tag)
            return tag

    return


studentTagManagerDirective = ->
    'ngInject'

    restrict: 'E'
    templateUrl: 'students/components/studentTagManager'
    scope: tags: '=', student: '='
    controller: studentTagManagerController
    bindToController: true
    controllerAs: 'ctrl'


module.directive 'dybStudentTagManager', studentTagManagerDirective